module.exports = __webpack_public_path__ + "img/logo.1ff3b5eb.png";